<template>
  <div class="doc-collection-wrap">
    <sidebar @updateHtml="updateHtml"></sidebar>
    <preview :html="html"></preview>
  </div>
</template>

<script>
import Sidebar from './sidebar/index'
import Preview from './preview'
export default {
  components: {
    Sidebar,
    Preview
  },
  mounted() {
    this.$LogReport.sendCustomEvent('openplat_techfile_page_load')
  },
  data() {
    return {
      html: ''
    }
  },
  methods: {
    updateHtml(html) {
      this.html = html
    }  
  },
}
</script>

<style lang="scss" scoped>
.doc-collection-wrap {
  // max-width: 1440px;
  // margin: 0 auto;
  // padding: 32px 16px;
  min-height: calc(100% - 64px);
  box-sizing: border-box;
}
</style>